import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy } from '@angular/core';
import { McpAdapterService, McpMessageEvent } from '../service/mcp-adapter.service';
import { WjGridModule } from '@mescius/wijmo.angular2.grid';
import { Subscription } from 'rxjs';
import { CollectionView } from '@mescius/wijmo';

interface MessageLog {
    number: number;
    direction: string;
    type: string;
    data: string;
}

@Component({
    selector: 'app-mcp-connector',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjGridModule
    ],
    templateUrl: './mcp-connector.component.html',
    styleUrl: './mcp-connector.component.scss',
})
export class McpConnectorComponent implements AfterViewInit, OnDestroy {

    protected messages = new CollectionView<MessageLog>();

    protected readonly mcpAdapter = inject(McpAdapterService);
    private onMessageSubscription: Subscription;

    ngAfterViewInit(): void {
        this.onConnect();
    }

    protected onConnect() {
        this.onMessageSubscription = this.mcpAdapter.onMessageSubject.subscribe(this.onMessage.bind(this))
        this.mcpAdapter.connect();
    }

    protected onDisconnect() {
        // this.mcpAdapter.disconnect();
    }

    ngOnDestroy(): void {
        this.onMessageSubscription.unsubscribe();
    }

    private onMessage (event: McpMessageEvent) {
        console.log(`Received message: ${JSON.stringify(event)}`);
        this.messages.deferUpdate(() => {
            const item: MessageLog = {
                number: this.messages.sourceCollection.length + 1,
                direction: event.direction.charAt(0),
                type: event.message.type,
                data: JSON.stringify(event.message.data)
            };
            this.messages.sourceCollection.push(item);
        });
    }

    protected async onCopyPromptToClipboard() {
        const prompt = `Use MCP Excel-Introspection, fileId = ${this.mcpAdapter.sessionId}: `;
        await navigator.clipboard.writeText(prompt);
    }
}
